import { __assign, __extends } from "tslib";
import React, { Component } from 'react';
import { PnmacText } from 'pnmac-universal-components';
import { View, Image } from 'react-native';
//import FadeLoader from "react-spinners/FadeLoader";
import * as Actions from '../redux/actions/actions.js';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
var BillMatrixHolder = /** @class */function (_super) {
  __extends(BillMatrixHolder, _super);
  function BillMatrixHolder(props) {
    var _this = _super.call(this, props) || this;
    _this.state = {};
    return _this;
  }
  BillMatrixHolder.prototype.componentDidMount = function () {
    var channel = new BroadcastChannel('app-data');
    channel.addEventListener('message', function (event) {
      var billMatrix = event.data;
      if (billMatrix) {
        if (billMatrix === null || billMatrix === void 0 ? void 0 : billMatrix.error) {
          window.close();
        } else {
          var data = billMatrix;
          var form = document.createElement("form");
          form.setAttribute("method", "post");
          form.setAttribute("action", data.urlToPost);
          var hdnResponseField = document.createElement("input");
          hdnResponseField.setAttribute("type", "hidden");
          hdnResponseField.setAttribute("name", "SAMLResponse");
          hdnResponseField.setAttribute("value", data.base64EncodedSaml);
          hdnResponseField.setAttribute("id", "test_sub");
          var hdnRelayField = document.createElement("input");
          hdnRelayField.setAttribute("type", "hidden");
          hdnRelayField.setAttribute("name", "RelayState");
          hdnRelayField.setAttribute("value", "PaymentWorkflow");
          form.appendChild(hdnResponseField);
          form.appendChild(hdnRelayField);
          document.body.appendChild(form);
          form.submit();
        }
      }
    });
  };
  BillMatrixHolder.prototype.render = function () {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(View, {
      style: {
        padding: 10,
        backgroundColor: "#efefef",
        borderBottomWidth: 1,
        borderBottomColor: "#DDD"
      }
    }, /*#__PURE__*/React.createElement(Image, {
      style: {
        height: 30,
        width: 280
      },
      source: require('../assets/IDSPennyHomeLogoInterstitial.svg')
    })), /*#__PURE__*/React.createElement(View, {
      style: {
        height: 400,
        backgroundColor: "#EFEFEF",
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center"
      }
    }, /*#__PURE__*/React.createElement(View, null), /*#__PURE__*/React.createElement(View, {
      style: {
        paddingRight: 20
      }
    }, /*#__PURE__*/React.createElement(PnmacText, {
      style: {
        fontWeight: "bold"
      }
    }, "Redirecting you to BillMatrix"))));
  };
  return BillMatrixHolder;
}(Component);
var mapStateToProps = function (state) {
  return {
    layout: state,
    translations: state.translations
  };
};
var mapDispatchToProps = function (dispatch) {
  return __assign({
    dispatch: dispatch
  }, bindActionCreators(Actions, dispatch));
};
export default connect(mapStateToProps, mapDispatchToProps)(BillMatrixHolder);